

import React, {Component} from 'react'
import { connect } from 'react-redux'
import CategoryItem from './components/category/CategoryItem'

var saleCommonUtility = require('../../utils/domain/sales/saleCommonUtility');
var snoozeUtil = require('../../utils/domain/snoozeUtil');
var constants = require('../../utils/domain/constants');

class CategoryItems extends Component 
{
    render()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        if (saleContext.selectedCategory == null)
            return null;

        let components = [];
        let selectedCategory = saleContext.selectedCategory;
        for (var index = 0; index < selectedCategory.items.length; index++)
        {
            let item = selectedCategory.items[index];
            let isSnoozed = snoozeUtil.isItemSnoozedForSale(item, constants.SnoozeItemTypes.categoryItem, 
                saleContext.primaryMenu, sale);

            var enabled = item.enabled && saleCommonUtility.canEditSale(saleContext) && saleCommonUtility.isTodaysBusinessDateSale(sale) &&
                          !isSnoozed;

            components.push(<CategoryItem item={item} category={selectedCategory} 
                                          enabled={enabled} isSnoozed={isSnoozed}
                                          saleContext={saleContext}/>);
        }

        return (<div className='h-100' style={{ overflowY:'auto',padding: "20px 12px"}}>
                    <div style={{display:'flex', flexWrap:'wrap', flexDirection:'row', gap:"4px"}}>
                        {components}
                    </div>
                </div>)
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                menuChangedDateTime: state.saleContext.menuChangedDateTime
           }
}

export default connect(mapStateToProps)(CategoryItems)